export default __webpack_public_path__ + "media/images/home/slide_yakai_2026_lg-d2bad65cc138ca07b24422e6499cd45f.jpg";